export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  useHead({
    script: [
      {
        src: `${config.app.baseURL}pcloud/pay-js-sdk/pay-js-sdk-2.4.1.min.js`.replace(
          /\/+/g,
          '/',
        ),
        async: true,
      },
    ],
  })
})
